module.exports = __webpack_public_path__ + "img/image00007.cb653e67.jpeg";